module.exports = __webpack_public_path__ + "img/fwx1.9c06c774.png";